export default __webpack_public_path__ + "static/media/homepage-dark-theme-img.4b0876d5.png";